<script setup lang="ts">
import type { Component } from 'vue';
import BDialog from 'shared/components/base/BDialog/BDialog.vue';

interface Props {
  /** The drill kind's results card (useDrillComponents().resultsComponent). */
  resultsComponent: Component | null;
  currentStepResults: unknown;
  errorCount: number;
  correctCount: number;
  timeAccumulator: number;
  score: number;
  stackSource: unknown;
  drillType: unknown;
  stepTypeComponent: string | null | undefined;
}

defineProps<Props>();

const emit = defineEmits<{ hide: [] }>();

const isOpen = defineModel<boolean>('isOpen', { default: false });
</script>

<template>
  <BDialog
    v-model:is-open="isOpen"
    position="bottom"
    card-class="bg-accent text-dark dialog-surface"
    title="INTERIM_RESULTS"
    @hide="emit('hide')"
  >
    <component
      :is="resultsComponent"
      :current-step-results="currentStepResults"
      :error-count="errorCount"
      :correct-count="correctCount"
      :time-accumulator="timeAccumulator"
      :score="score"
      :stack-source="stackSource"
      :drill-type="drillType"
      :step-type-component="stepTypeComponent"
    />
  </BDialog>
</template>
